module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "global-sul-logo absolute",
    attrs: {
      "src": require("img/sul-logo.svg")
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('div', {
    staticClass: "homeview-section logo"
  }, [(_vm.$i18n.locale == 'se') ? _c('img', {
    attrs: {
      "src": require("img/kunniakierros-logo-se.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("img/kunniakierros-logo-fi.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "homeview-section blue-section"
  }, [(_vm.store.selectedEvent) ? _c('div', {
    staticClass: "sponsor-count-circle"
  }, [_c('div', {
    staticClass: "per-lap-sum"
  }, [_vm._v("\r\n                    " + _vm._s(_vm.sumPerLap) + "\r\n                    "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "per-lap-label"
  }, [_vm._v(_vm._s("€" + _vm.$t("homeView.perLap")))])])]) : _vm._e(), _vm._v(" "), (_vm.store.selectedEvent) ? _c('div', {
    staticClass: "sponsor-payment-info"
  }, [(_vm.participatingSponsorCount > 0) ? _c('div', [_vm._v("\r\n                    " + _vm._s(_vm.$t("homeView.sponsorsParticipating", [_vm.participatingSponsorCount])) + "\r\n                    " + _vm._s(_vm.$t("homeView.totalSponsorPayments")) + " " + _vm._s(_vm.$n(_vm.totalSponsorPayments, "currency")) + "\r\n                ")]) : _c('div', [_vm._v("\r\n                    " + _vm._s(_vm.$t("homeView.addOrInviteSponsors")) + "\r\n                ")])]) : _c('div', [_vm._v("\r\n                " + _vm._s(_vm.$t("homeView.noEvent")) + "\r\n                "), (!_vm.store.currentUser.organizations) ? _c('div', [_vm._v("\r\n                    " + _vm._s(_vm.$t("homeView.noOrganization")) + "\r\n                ")]) : _vm._e()])]), _vm._v(" "), (_vm.store.selectedEvent) ? _c('div', {
    staticClass: "homeview-section lap-goal"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("homeView.event")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("homeView.eventInfo")))]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "button button-green",
    on: {
      "click": function($event) {
        _vm.chooseOrganization()
      }
    }
  }, [_vm._v("\r\n                    " + _vm._s(_vm.store.selectedOrganization.name) + "\r\n                    "), _c('span', {
    staticClass: "icon-arrow-right2"
  })])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "button button-green",
    on: {
      "click": function($event) {
        _vm.chooseEvent()
      }
    }
  }, [_vm._v("\r\n                    " + _vm._s(_vm.store.selectedEvent.name) + "\r\n                    "), _c('span', {
    staticClass: "icon-arrow-right2"
  })])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "button button-green",
    on: {
      "click": function($event) {
        _vm.editLaps()
      }
    }
  }, [_vm._v("\r\n                    " + _vm._s(_vm.$t("homeView.repeats")) + "\r\n                    "), _c('span', {
    staticClass: "icon-arrow-right2"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.store.selectedEvent) ? _c('div', {
    staticClass: "homeview-section"
  }, [_c('div', [_c('button', {
    staticClass: "button button-green",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showSponsors()
      }
    }
  }, [_vm._v("\r\n                    " + _vm._s(_vm.$t("homeView.sponsors")) + "\r\n                ")])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "button button-green",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.inviteSponsor()
      }
    }
  }, [_vm._v("\r\n                    " + _vm._s(_vm.$t("homeView.inviteSponsor")) + "\r\n                ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "homeview-section blue-section"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("homeView.infoTitle")))]), _vm._v(" "), _c('button', {
    staticClass: "button button-green",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.permission()
      }
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t("homeView.permit")) + "\r\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "button button-green",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.instructions()
      }
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t("homeView.instructions")) + "\r\n            ")])])]) : _c('div', [_c('KkSpinner')], 1), _vm._v(" "), _c('kk-popup')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-274a7d54","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/ts/views/HomeView.vue
// module id = 114
// module chunks = 0